import type { FlagGlossaryFilterValues } from './flagGlossary.types';

export const FLAG_GLOSSARY_DEFAULT_FILTER_VALUES: FlagGlossaryFilterValues = {
  severityTab: 'ALL',
  categoryFilter: 'any',
  search: '',
};

export const hasFlagGlossaryActiveFilters = (
  filters: FlagGlossaryFilterValues,
): boolean =>
  filters.severityTab !== FLAG_GLOSSARY_DEFAULT_FILTER_VALUES.severityTab ||
  filters.categoryFilter !==
    FLAG_GLOSSARY_DEFAULT_FILTER_VALUES.categoryFilter ||
  filters.search.trim() !== FLAG_GLOSSARY_DEFAULT_FILTER_VALUES.search;
